import React from 'react'
import './Errors.scss'

export function Errors ({ messages = [] }) {
    messages = messages.filter(message => !!message);
    if (!messages.length) return null

    return (
        <ul className={'Errors'}>
            {messages.map((message, index) => (
                <li className={'Errors-item'} key={index}>{message}</li>
            ))}
        </ul>
    )
}